module.exports = __webpack_public_path__ + "img/logo-skype.320e51be.svg";